const en = {
  // Navigation
  'nav.models': 'Models',
  'nav.pricing': 'Pricing',
  'nav.docs': 'Docs',
  'nav.console': 'Console',
  'nav.home': 'Home',
  'nav.toggleTheme': 'Toggle theme',
  'nav.langId': 'Bahasa Indonesia',
  'nav.langEn': 'English',

  // Footer
  'footer.tagline':
    'Access AI models through one OpenAI-compatible endpoint, with prepaid balance and per-1-million-token prices listed in the catalog.',
  'footer.product': 'PRODUCT',
  'footer.legal': 'LEGAL',
  'footer.models': 'Models',
  'footer.pricing': 'Pricing',
  'footer.docs': 'Docs',
  'footer.changelog': 'Changelog',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.emailIntro': 'Email us at',
  'footer.rights': 'All rights reserved.',

  // 404
  'notfound.title': "This page doesn't exist.",
  'notfound.body':
    'The link is broken or the page moved. Check the URL, or head back to a page that works.',
  'notfound.home': 'Back home',
  'notfound.docs': 'Read the docs',

  // Login
  'login.welcomeBack': 'WELCOME BACK',
  'login.title': 'Sign in to your OpenCSN console.',
  'login.subtitle':
    'Manage API keys, track token usage, and see per-model cost in one place.',
  'login.cardTitle': 'Sign in',
  'login.cardSubtitle': 'Sign in to continue.',
  'login.google': 'Sign in with Google',
  'login.or': 'OR',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Sign In',
  'login.noAccount': "Don't have an account?",
  'login.signup': 'Sign up',
  'login.forgot': 'Forgot password?',
  'login.legalNotice': 'By continuing, you agree to the {terms} and the {privacy}.',

  // Register
  'register.title': 'Create an account',
  'register.subtitle': 'Register to get started.',
  'register.google': 'Sign up with Google',
  'register.closed': 'Email sign-up is closed right now. Use a Google account to sign in.',
  'register.haveAccount': 'Already have an account?',
  'register.signin': 'Sign in',
  'register.legalNotice': 'By continuing, you agree to the {terms} and the {privacy}.',

  // Toasts
  'toast.loginRequired': 'Sign in first to access the console.',
  'toast.devOnly': 'The developer console is available only to developer accounts.',
  'toast.logout': 'You have signed out.',
  'toast.welcome': 'Welcome, {name}.',
  'toast.authFailed': 'Authorization failed: {message}',
  'toast.turnstileRequired': 'Complete the Cloudflare Turnstile check first.',

  // Common
  'common.free': 'Free',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.reset': 'Reset',
  'common.all': 'All',
  'common.none': 'None',

  // Meta
  'meta.home': 'OpenCSN - AI model API gateway',
  'meta.pricing': 'Pricing - OpenCSN',
  'meta.models': 'Models - OpenCSN',
  'meta.docs': 'Documentation - OpenCSN',
  'meta.changelog': 'Changelog - OpenCSN',
  'meta.login': 'Sign in - OpenCSN',
  'meta.register': 'Create an account - OpenCSN',
  'meta.notfound': 'Page not found - OpenCSN',

  // Landing Page
  'landing.heroTitle1': 'Like OpenRouter.',
  'landing.heroTitle2': 'But more saving.',
  'landing.heroSubtitle': 'One API. Real models. Lower prices. More free AI.',
  'landing.getApiKey': 'Get API Key',
  'landing.browseModels': 'Browse models',
  'landing.signup': 'Sign up',
  'landing.featOpenAI': 'OpenAI-compatible endpoint',
  'landing.featGateway': 'OpenCSN unified gateway',
  'landing.featConfig': 'Centralized model configuration',
  'landing.terminalTitle': 'Terminal',
  'landing.providersTitle': 'Compatible with leading AI providers and tools',
  'landing.agentsTitle': 'One gateway for every coding agent',
  'landing.agentsSubtitle': 'Claude Code, Codex, Cursor, or any agent. Route through OpenCSN without modifying your application logic.',
  'landing.stepsHeading': 'Up and running in minutes',
  'landing.stepsTagline': 'One key, every model, zero setup.',
  'landing.step1Title': 'Create an account',
  'landing.step1Desc': 'Sign up for a developer account. Direct access to the console and API key management.',
  'landing.step2Title': 'Add credits',
  'landing.step2Desc': 'Top up prepaid balance as needed. Balance never expires.',
  'landing.step2Action': 'See pricing',
  'landing.step3Title': 'Make your first call',
  'landing.step3Desc': 'Use the standard OpenAI or Anthropic SDKs pointing directly at the gateway endpoint.',
  'landing.step3Action': 'Quickstart',
  'landing.faqHeading': 'Frequently asked questions',
  'landing.faqTagline': 'Technical and operational details before routing production traffic to OpenCSN.',
  'landing.faqDocs': 'Full documentation',
  'landing.faq1Q': 'What is OpenCSN?',
  'landing.faq1A': 'OpenCSN is a multi-model API gateway and operational console providing access to multiple model providers through a single endpoint.',
  'landing.faq2Q': 'Why use a gateway instead of calling providers directly?',
  'landing.faq2A': 'Direct integration fragments routing, credentials, and cost tracking. OpenCSN unifies access under a single API key and prepaid balance.',
  'landing.faq3Q': 'Are prompt or response contents stored?',
  'landing.faq3A': 'No. OpenCSN operates a strict Zero Data Retention (ZDR) policy: prompt and response contents are not stored in our database or logs.',
  'landing.faq4Q': 'How does billing work?',
  'landing.faq4A': 'The service uses prepaid balance. Charges are deducted based on actual token counts at the per-1M-token rate shown in the catalog.',
  'landing.faq5Q': 'Is the API format compatible with standard SDKs?',
  'landing.faq5A': 'Yes. The gateway is fully compatible with OpenAI Chat Completions and Anthropic Messages. Simply point your baseURL to OpenCSN.',

  // Pricing Page
  'pricing.title': 'Pay only for what you use.',
  'pricing.subtitle': 'No monthly minimum, no lock-in. Top up any amount and pay per token at the rate listed on each model.',
  'pricing.waysToPay': 'Ways to pay',
  'pricing.waysToPayDesc': 'Pay per token, or select a prepaid plan with higher rate limits and concurrency.',
  'pricing.paygBadge': 'PAY AS YOU GO',
  'pricing.perToken': 'Per token',
  'pricing.paygDesc': 'You are charged for exactly what you use, at the rate listed on each model.',
  'pricing.createAccount': 'Create an account',
  'pricing.whatsIncluded': "WHAT'S INCLUDED",
  'pricing.paygBullet1': 'Access to all 28 models in the catalog',
  'pricing.paygBullet2': 'Includes free models at zero cost per token',
  'pricing.paygBullet3': 'Standard rate limit of 60 requests per minute',
  'pricing.paygBullet4': 'Prepaid credits never expire',
  'pricing.calcTitle': 'Usage calculator',
  'pricing.calcSubtitle': 'Estimated tokens you receive based on your chosen budget.',
  'pricing.customAmount': 'Custom balance amount (USD)',
  'pricing.topupBtn': 'Top up now',

  // Models Directory & Detail
  'models.title': 'AI Model Directory',
  'models.subtitle': 'Compare models, input and output prices per 1M tokens, context length, and capabilities.',
  'models.statModels': 'MODELS',
  'models.statProviders': 'PROVIDERS',
  'models.statFree': 'FREE',
  'models.filters': 'Filters',
  'models.providers': 'PROVIDERS',
  'models.searchProviders': 'Search providers...',
  'models.priceRange': 'PRICE RANGE',
  'models.allPrices': 'All prices',
  'models.freeOnly': 'Free only',
  'models.under1': 'Under $1/M',
  'models.1to5': '$1 – $5/M',
  'models.5to15': '$5 – $15/M',
  'models.over15': '$15+/M',
  'models.pricingType': 'PRICING TYPE',
  'models.discounted': 'Discounted',
  'models.searchPlaceholder': 'Search model name or ID...',
  'models.sortBy': 'Sort by:',
  'models.sortProvider': 'Provider (A-Z)',
  'models.sortPriceAsc': 'Price: Low to High',
  'models.sortPriceDesc': 'Price: High to Low',
  'models.sortName': 'Model Name (A-Z)',
  'models.sortContext': 'Context Length',
  'models.viewGrid': 'Grid',
  'models.viewList': 'List',
  'models.thModel': 'MODEL',
  'models.thContext': 'CONTEXT',
  'models.thInput': 'INPUT / 1M',
  'models.thOutput': 'OUTPUT / 1M',
  'models.thPerks': 'PERKS',
  'models.thActions': 'ACTIONS',
  'models.detailBack': 'Back to all models',
  'models.detailUseModel': 'Use this model',
  'models.detailCopyId': 'Copy ID',
  'models.detailContext': 'Context Window',
  'models.detailInputPrice': 'Input Token Price',
  'models.detailOutputPrice': 'Output Token Price',
  'models.detailCapabilities': 'Model Capabilities',
  'models.detailVision': 'Vision',
  'models.detailReasoning': 'Reasoning',
  'models.noResults': 'No models match your current filters.',

  // Changelog
  'changelog.badge': 'Changelog',
  'changelog.title': "What's new",
  'changelog.subtitle': 'Every model addition, pricing update, and gateway improvement, in one timeline.',
  'changelog.tagModel': 'Model',
  'changelog.entry1Title': 'Kimi K3.1 Pro',
  'changelog.entry1Desc': 'Flagship model Kimi K3.1 Pro from Moonshot AI is now active on the OpenCSN gateway.',
  'changelog.entry2Title': 'DeepSeek v4.1 Flash Uncensored',
  'changelog.entry2Desc': 'DeepSeek v4.1 Flash Uncensored available for rapid inference without added guardrails.',
  'changelog.entry3Title': 'DeepSeek v4.1 Flash Update 1017',
  'changelog.entry3Desc': 'Stable build 1017 enabled automatically without requiring model ID changes.',
  'changelog.entry4Title': 'DeepSeek v4.1 Flash Free Tier',
  'changelog.entry4Desc': 'DeepSeek v4.1 Flash model accessible at zero token cost during evaluation period.',

  // Forgot Password
  'forgot.title': 'Reset password',
  'forgot.step1Subtitle': 'Enter your email address to receive a 6-digit OTP verification code.',
  'forgot.step2Subtitle': 'Enter the 6-digit OTP code sent to your email and your new password.',
  'forgot.emailLabel': 'Email address',
  'forgot.sendBtn': 'Send OTP Code',
  'forgot.changeEmail': 'Change email',
  'forgot.otpLabel': '6-Digit Verification Code (OTP)',
  'forgot.newPasswordLabel': 'New Password',
  'forgot.newPasswordPlaceholder': 'Min. 6 characters',
  'forgot.confirmPasswordLabel': 'Confirm New Password',
  'forgot.confirmPasswordPlaceholder': 'Confirm new password',
  'forgot.submitBtn': 'Reset Password',
  'forgot.resendOtp': 'Resend OTP code',
  'forgot.rememberPassword': 'Remember your password?',
  'forgot.signin': 'Sign in',

  // Command Palette
  'cmd.overview': 'Overview',
  'cmd.models': 'Models',
  'cmd.usage': 'Usage',
  'cmd.developer': 'Developer',
  'cmd.billing': 'Billing',
  'cmd.system': 'System',
  'cmd.public': 'Public',
  'cmd.placeholder': 'Type a command or search pages...',
  'cmd.empty': 'No matching pages found for "{query}"',
  'cmd.quickNav': 'Quick navigation',

  // Docs Navigation
  'docs.badge': 'Docs',
  'docs.searchPlaceholder': 'Search documentation...',
  'docs.startHere': 'Start here',
  'docs.apiReference': 'API reference',
  'docs.guides': 'Guides',
  'docs.backToApp': 'To App',
  'docs.onThisPage': 'On this page',
  'docs.prev': 'Previous',
  'docs.next': 'Next',

  // Billing & Redeem
  // API keys
  'keys.neverExpires': 'No expiration',
  'keys.expiresNever': 'No expiration',
  'keys.expires30': 'In 30 days',
  'keys.expires60': 'In 60 days',
  'keys.expires90': 'In 90 days',
  'keys.expires1y': 'In 1 year',
  'keys.badgeActive': 'Active',
  'keys.badgeBlocked': 'Blocked',
  'keys.copyTitle': 'Copy your API key now',
  'keys.copyOnce': 'Copy {name} below. This secret is shown only now: the server keeps only its hash, so it cannot be shown again.',
  'keys.copy': 'Copy',
  'keys.copyRotateHint': 'If you lose it, create a new key or use Rotate: rotating issues a replacement secret and the old one stops working.',
  'keys.savedCheckbox': 'I have saved this key somewhere safe.',
  'keys.done': 'Done',
  'keys.rotateTitle': 'Rotate this key?',
  'keys.rotateBody': 'Rotate this key? The current secret will stop working immediately and a new one will be issued.',
  'keys.cancel': 'Cancel',
  'keys.rotateConfirm': 'Rotate key',
  'keys.newKeyCreatedTitle': 'New API key created',
  'keys.newKeyWarning': 'This is the only time the full key is shown. Store it somewhere safe. The old key no longer works.',
  'keys.savedIt': 'I have saved it',
  'keys.rotate': 'Rotate',
  'keys.rotateFailed': 'Rotation failed.',
  'keys.rotated': 'API key "{name}" rotated.',
  'keys.revokeTitle': 'Revoke this key?',
  'keys.revokeBody': '"{name}" will stop working immediately. Any client still using it will start failing.',
  'keys.revokeConfirm': 'Revoke key',
  'keys.revoke': 'Revoke',
  'keys.revokeFailed': 'Revocation failed.',
  'keys.revoked': 'API key "{name}" revoked.',
  'keys.pendingRemoteDelete': 'Key revoked. Removal from the gateway is queued and finishes shortly.',
  'keys.statusFailed': 'Status change failed.',
  'keys.block': 'Block',
  'keys.unblock': 'Unblock',
  'keys.createFailed': 'Key creation failed.',
  'keys.created': 'Created API key "{name}".',
  'keys.fallbackName': 'Key',
  'billing.enterCode': 'Please enter a redemption code.',
  'billing.lowBalanceBanner': 'Your balance is low ($1.00 or less). Add credit to prevent API requests from pausing.',
  'usage.costMismatchTooltip': 'Component breakdown estimate unavailable (using authoritative gateway spend).',
  // Dev model management
  'mgmt.importFailed': 'Import failed.',
  'mgmt.importDone': '{count} model(s) imported.',
  'mgmt.priceRequired': 'An Active model needs input and output prices above zero, or the free flag.',
  'mgmt.saveFailed': 'Save failed.',
  'mgmt.nowActive': '{name} is now Active.',
  'mgmt.nowHidden': '{name} is now Hidden.',
  'mgmt.descRestored': 'Description restored for {name}.',
  'mgmt.discountReset': 'Discount reset to 0% for {name}.',
  'mgmt.discountApplied': '{pct}% discount applied to {name}.',
  'mgmt.saved': 'Changes saved for {name}.',
  'mgmt.emptyCatalog': 'The catalog is empty.',
  'mgmt.emptyCatalogHint': 'Import from LiteLLM or add a model to begin.',
  'mgmt.catalogImport': 'Import from LiteLLM',
  'mgmt.statusActive': 'Active',
  'mgmt.statusHidden': 'Hidden',
  'mgmt.statusDraft': 'Draft',
  'mgmt.totalModels': 'Total Models',
  'mgmt.publiclyActive': 'Publicly Active',
  'mgmt.hiddenCount': 'Hidden',
  'mgmt.selectedModel': 'Selected Model',
  'mgmt.selectModel': 'Select Model AI to Configure',
  'mgmt.addModel': 'Add Model',
  'mgmt.inLiteLLM': 'Present in LiteLLM',
  'mgmt.notInLiteLLM': 'Absent in LiteLLM',
  'mgmt.saveChanges': 'Save Changes',
  'mgmt.deleteModel': 'Delete Model',
  'mgmt.visibility': 'Public Access Visibility',
  'mgmt.visibilityActive': 'PUBLIC ACCESS: ACTIVE',
  'mgmt.visibilityHidden': 'PUBLIC ACCESS: HIDDEN',
  'mgmt.visibilityDraft': 'PUBLIC ACCESS: DRAFT',
  'mgmt.visibilityHintActive': 'Visible on the public catalog.',
  'mgmt.visibilityHintHidden': 'Hidden from the public catalog.',
  'mgmt.visibilityHintDraft': 'Not registered in LiteLLM yet.',
  'mgmt.description': 'Model AI Description',
  'mgmt.restoreDescription': 'Restore Default Description',
  'mgmt.livePreview': 'Live Card Preview',
  'mgmt.noDescription': 'No description provided.',
  'mgmt.pricingBars': 'Interactive Pricing Bars',
  'mgmt.pricingHint': 'Drag the sliders or use the numeric controls per 1M tokens.',
  'mgmt.promos': 'Promos:',
  'mgmt.basePrice': 'Base 0%',
  'mgmt.rateInput': 'Input Rate (per 1M tokens)',
  'mgmt.rateCacheRead': 'Cache Read Rate (per 1M tokens)',
  'mgmt.rateCacheWrite': 'Cache Write Rate (per 1M tokens)',
  'mgmt.rateOutput': 'Output Rate (per 1M tokens)',
  'mgmt.distribution': 'Relative Price Distribution (1M tokens)',
  'mgmt.supplierCost': 'Supplier Cost',
  'mgmt.supplierCostHint': 'Internal cost per 1M tokens. The margin appears per field.',
  'mgmt.parameters': 'Model Parameters',
  'mgmt.context': 'Context',
  'mgmt.maxOutput': 'Max output tokens',
  'mgmt.upstreamModel': 'Upstream model',
  'mgmt.badge': 'Badge',
  'mgmt.vision': 'Vision',
  'mgmt.reasoning': 'Reasoning',
  'mgmt.freeModel': 'Free model',
  'mgmt.history': 'Price History',
  'mgmt.historyRefresh': 'Refresh',
  'mgmt.historyEmpty': 'No price change recorded yet.',
  'mgmt.when': 'When',
  'mgmt.thInput': 'Input / 1M',
  'mgmt.thOutput': 'Output / 1M',
  'mgmt.thCacheRead': 'Cache Read / 1M',
  'mgmt.thCacheWrite': 'Cache Write / 1M',
  'mgmt.thDiscount': 'Discount',
  'mgmt.saveParameters': 'Save Model Parameters',
  'mgmt.matrix': 'Complete Models Matrix',
  'mgmt.matrixHint': 'Toggle visibility or select a model to tune its prices.',
  'mgmt.filter': 'Filter models...',
  'mgmt.filterAll': 'All ({count})',
  'mgmt.filterActive': 'Active ({count})',
  'mgmt.filterHidden': 'Hidden ({count})',
  'mgmt.thModel': 'Model',
  'mgmt.thProvider': 'Provider',
  'mgmt.thStatus': 'Status',
  'mgmt.thActions': 'Actions',
  'mgmt.tune': 'Tune',
  'mgmt.modelId': 'Model ID',
  'mgmt.upstreamModelHint': 'Enter it exactly as LiteLLM needs it, including any provider prefix.',
  'mgmt.cancel': 'Cancel',
  'mgmt.create': 'Create',
  'mgmt.createRequired': 'Model ID and upstream model are required.',
  'mgmt.createFailed': 'Create failed.',
  'mgmt.created': 'Model {id} created.',
  'mgmt.deleteConfirm': 'Delete {name}? It is also removed from LiteLLM when present.',
  'mgmt.deleteFailed': 'Delete failed.',
  'mgmt.deleted': 'Model {id} deleted.',
  'mgmt.freeTier': 'Free Tier',
  'mgmt.directInput': 'Direct Input:',
  'billing.redeemSuccess': 'Success! Your account balance has been updated.',
  'catalog.live': 'Live stream',
  'catalog.stale': 'Stale connection',
  'catalog.justNow': 'Updated just now',
  'catalog.updatedAgo': 'Updated {seconds}s ago',
  'catalog.connecting': 'Connecting...',
  'leaderboard.thSuccessRate': 'Success Rate',
  'leaderboard.thAvgLatency': 'Avg Latency',
};

export default en;
